import { createSelector } from 'reselect';
import { TApplicationState, TStatisticsState } from '../../libs/store';

const statisticsState = (state: TApplicationState) => state?.statistics;

export const statisticsStateSelector = createSelector(statisticsState, (state: TStatisticsState) => state?.stats ?? {});
export const tierTalentsStateSelector = createSelector(
  statisticsState,
  (state: TStatisticsState) => state?.tierTalents ?? {}
);
export const tierGearStateSelector = createSelector(
  statisticsState,
  (state: TStatisticsState) => state?.tierGear ?? {}
);
export const tierTrinketsStateSelector = createSelector(
  statisticsState,
  (state: TStatisticsState) => state?.tierTrinkets ?? {}
);
